module.exports = __webpack_public_path__ + "img/card-i2.4000517f.png";